import React from 'react'

const Thirty_two = () => {
    return (
        <div className='container'>
            <h1>Linear Search</h1>
            
          <p>  Linear search in C to find whether a number is present in an array.
             If it's present, then at what location it occurs. It is also known as 
             a sequential search. It is straightforward and works as follows: we 
             compare each element with the element to search until we find it or 
             the list ends. Linear search for multiple occurrences and using a function. <br />
             Example: <br />
             Input: <br />
             Enter the number of elements in array <br />
             5 <br />
             Enter 5 numbers: <br />
             5 6 4 2 9 <br />
             Enter the number to search:
             4 <br />
             4 is present at location 3
          </p>
            <div className='containers'>
           <code className='library'> #include</code>  &lt;stdio.h &gt;<br/>
           <code className='library'>int</code> main()
 &#123;<br/>
 <code className='keywords'> int</code> array[100], search, c, n;<br/>

 <code className='library'> printf</code>("Enter number of elements in array\n");<br/>
 <code className='library'>scanf</code>("%d", &n);<br/>

 <code className='library'>printf</code>("Enter %d integer(s)\n", n);<br/>

 <code className='keywords'>for</code> (c = 0; c &lt; n; c++)
 <code className='library'> scanf</code>("%d", &array[c]);<br/>

 <code className='library'>printf</code>("Enter a number to search\n");<br/>
 <code className='library'>scanf</code>("%d", &search);<br/>

 <code className='keywords'>for</code> (c = 0; c &lt; n; c++)
   &#123;<br/>
   <code className='library'>  if</code> (array[c] == search)    /* If required element is found */<br/>
     &#123;<br/>
     <code className='library'>  printf</code>("%d is present at location %d.\n", search, c+1);<br/>
     <code className='keywords'>  break;</code><br/>
   &#125;<br/> 
  &#125;<br/>
  <code className='keywords'>if </code>(c == n)
  <code className='library'> printf</code>("%d isn't present in the array.\n", search);<br/>

  <code className='library'> return</code> 0;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Thirty_two